import React from "react";
import { Paragraph } from "_styleguide";
import { IconInfoCircle, IconAlertTriangle } from "@tabler/icons-react";
import { flatMoney } from "_assets/js/helpers";
import "./CreditAlert.scss";

function CreditAlert(props) {
  const { pageSettings, eligibleBalance, selectedAmount } = props;

  let type = null;
  if (eligibleBalance < (pageSettings.minimum_debt_amount || 0)) {
    type = "warning";
  } else if (selectedAmount < (pageSettings.minimum_selected_amount || 0)) {
    type = "error";
  } else {
    type = null;
  }

  return !type ? null : (
    <>
      {type === "error" ? (
        <div className={`credit-alert ${type}`}>
          <IconInfoCircle />
          <Paragraph>
            Select at least,{" "}
            <u>{flatMoney(pageSettings.minimum_selected_amount || 0)}</u> of
            your eligible credit lines to unlock savings.
          </Paragraph>
        </div>
      ) : (
        <div className={`credit-alert ${type}`}>
          <IconAlertTriangle />
          <Paragraph>
            There isn’t enough eligible credit available to continue. A rep will
            contact you shortly.
          </Paragraph>
        </div>
      )}
    </>
  );
}

export default CreditAlert;
